var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4434 14.0961H1.55448C1.3482 14.0961 1.15037 14.1763 1.00451 14.3192C0.858651 14.4621 0.776706 14.6559 0.776706 14.858C0.776706 15.06 0.858651 15.2538 1.00451 15.3967C1.15037 15.5396 1.3482 15.6199 1.55448 15.6199H12.4434C12.6497 15.6199 12.8475 15.5396 12.9933 15.3967C13.1392 15.2538 13.2212 15.06 13.2212 14.858C13.2212 14.6559 13.1392 14.4621 12.9933 14.3192C12.8475 14.1763 12.6497 14.0961 12.4434 14.0961ZM1.55448 12.5723H1.62448L4.86782 12.2827C5.2231 12.2481 5.5554 12.0947 5.80893 11.8484L12.8089 4.9913C13.0806 4.71013 13.2275 4.33492 13.2172 3.9479C13.207 3.56087 13.0406 3.19359 12.7545 2.92654L10.6234 0.838917C10.3452 0.58299 9.98076 0.436143 9.5993 0.426309C9.21783 0.416475 8.84598 0.544341 8.55448 0.785584L1.55448 7.64273C1.30308 7.89108 1.14654 8.2166 1.11115 8.56463L0.776706 11.7418C0.766229 11.8534 0.781011 11.9659 0.819999 12.0712C0.858986 12.1766 0.921219 12.2722 1.00226 12.3513C1.07494 12.4219 1.16113 12.4778 1.25589 12.5157C1.35065 12.5536 1.45212 12.5728 1.55448 12.5723ZM9.54226 1.90558L11.6656 3.98558L10.11 5.4713L8.0256 3.42939L9.54226 1.90558ZM2.62004 8.69415L6.99893 4.43511L9.09893 6.49225L4.74337 10.7589L2.41004 10.9722L2.62004 8.69415Z",
    fill: "#427CE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.fd80329a16727074c75654eb54bb38bd.svg";
export { ForwardRef as ReactComponent };